import React, { useState } from 'react';
import { toast } from 'sonner';
import { Plus, X, CheckCircle, Copy, EnvelopeSimple, Trash } from '@phosphor-icons/react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { fmtDate, buildInviteUrl } from './utils';

export const InvitationsTab = ({ invitations, onCreate, onDelete, onResend }) => {
  const [form, setForm] = useState({ name: '', email: '', role: 'employee' });
  const [justCreated, setJustCreated] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await onCreate(form);
    if (result?.token) {
      setJustCreated({ url: buildInviteUrl(result.token), email: form.email });
      setForm({ name: '', email: '', role: 'employee' });
    }
  };

  const copyUrl = (url) => {
    navigator.clipboard.writeText(url).then(() => toast.success('Lien copie'));
  };

  return (
    <>
      <div className="card" style={{ padding: '20px', marginBottom: '16px' }}>
        <h3 style={{ margin: '0 0 14px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '1rem' }}><Plus size={16} /> Creer une invitation</h3>
        <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr)) auto', gap: '12px', alignItems: 'end' }}>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label" style={{ fontSize: '0.8rem' }}>Nom *</label>
            <input type="text" className="form-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="invite-name" />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label" style={{ fontSize: '0.8rem' }}>Email *</label>
            <input type="email" className="form-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="invite-email" />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label" style={{ fontSize: '0.8rem' }}>Role</label>
            <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
              <SelectTrigger data-testid="invite-role"><SelectValue /></SelectTrigger>
              <SelectContent className="z-[9999]">
                <SelectItem value="employee">Salarie</SelectItem>
                <SelectItem value="admin">Administrateur</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <button type="submit" className="btn btn-primary" data-testid="create-invite-btn"><Plus size={14} /> Creer</button>
        </form>
      </div>

      {justCreated && (
        <div className="card" style={{ padding: '14px 18px', marginBottom: '16px', backgroundColor: '#E8F5E9', border: '1px solid #81C784' }} data-testid="invite-just-created">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', color: '#2E7D32', fontWeight: '600' }}><CheckCircle size={18} /> Invitation creee pour {justCreated.email}</div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <code style={{ flex: 1, background: 'white', padding: '8px', borderRadius: '4px', fontSize: '0.8rem', wordBreak: 'break-all' }}>{justCreated.url}</code>
            <button className="btn btn-secondary btn-sm" onClick={() => copyUrl(justCreated.url)}><Copy size={14} /> Copier</button>
            <button className="btn btn-secondary btn-sm" onClick={() => setJustCreated(null)}><X size={14} /></button>
          </div>
        </div>
      )}

      {invitations.length === 0 ? (
        <div className="card" style={{ padding: '32px', textAlign: 'center', color: '#5E5F66' }}>Aucune invitation en attente</div>
      ) : (
        <div className="card" style={{ overflow: 'auto' }}>
          <table className="data-table" data-testid="invitations-table">
            <thead><tr><th>Nom</th><th>Email</th><th>Role</th><th>Expire le</th><th>Cree le</th><th>Actions</th></tr></thead>
            <tbody>
              {invitations.map(inv => (
                <tr key={inv.id}>
                  <td style={{ fontWeight: '600' }}>{inv.name}</td>
                  <td>{inv.email}</td>
                  <td>{inv.role}</td>
                  <td style={{ fontSize: '0.85rem' }}>{fmtDate(inv.expires_at)}</td>
                  <td style={{ fontSize: '0.85rem', color: '#5E5F66' }}>{fmtDate(inv.created_at)}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '4px' }}>
                      <button className="btn btn-secondary btn-sm" onClick={() => onResend(inv.id, inv.email)} title="Renvoyer par email" data-testid={`resend-${inv.id}`}><EnvelopeSimple size={14} /></button>
                      <button className="btn btn-secondary btn-sm" onClick={() => copyUrl(buildInviteUrl(inv.token))} title="Copier le lien" aria-label="Copier le lien"><Copy size={14} /></button>
                      <button className="btn btn-danger btn-sm" onClick={() => onDelete(inv.id)} title="Supprimer"><Trash size={14} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};
